__webpack_require__.p = "/reports-translations-to-backend-migration-breakdown/account-setup/";